"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsDistributor = void 0;
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const material_ui_icons_1 = require("material-ui-icons");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const store_1 = require("../../store");
let AppSettingsDistributor = class AppSettingsDistributor extends React.Component {
    constructor() {
        super(...arguments);
        this.settings = null;
        this.valueInput = '';
        this.generateSettings = async () => {
            const settings = await store_1.appSettingsStore.readSettings();
            const distributorSettings = settings.filter((setting) => setting.category === app_settings_1.AppCategory.Distributor);
            this.settings = distributorSettings;
        };
        this.handleUpdateInput = () => (event, value) => {
            this.valueInput = value;
        };
        this.handleSubmit = async () => {
            if (!this.settings || !this.settings[0]) {
                console.error('No Setting found');
                return;
            }
            if (!this.valueInput.trim()) {
                console.error('Invalid value input');
                return;
            }
            const code = this.valueInput.trim();
            const categoryId = this.settings[0].id;
            const rejection = { code, categoryId };
            const result = await store_1.appSettingsStore.createRejection(rejection);
            this.valueInput = '';
            this.generateSettings();
        };
        this.handleDelete = async (code, categoryId) => {
            const rejection = { code, categoryId };
            const result = await store_1.appSettingsStore.deleteRejection(rejection);
            this.generateSettings();
        };
        this.renderAddNew = () => (React.createElement("div", { className: "settings__add--wrapper", style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            } },
            React.createElement(text_field_1.MaterialTextField, { label: "Shipping Method", required: true, placeholder: "", value: this.valueInput || "", onChange: this.handleUpdateInput() }),
            React.createElement(button_1.MaterialButton, { primary: true, disabled: !this.valueInput, onClick: this.handleSubmit }, "Add")));
    }
    async componentDidMount() {
        await this.generateSettings();
    }
    async componentWillUnmount() {
        this.settings = null;
    }
    renderSettings() {
        const settings = this.settings;
        const groups = [];
        const blocks = [];
        settings.forEach((setting, i) => {
            const groupName = setting.category;
            if (!groups.includes(groupName))
                groups.push(groupName);
        });
        groups.forEach((group, i) => {
            blocks.push(React.createElement("div", { className: "settings__block", key: i },
                React.createElement("h3", { className: "settings__block-title", id: group }, group.toUpperCase()),
                React.createElement("div", { className: "settings__block-entries" }, settings
                    .filter((setting) => setting.category === group)
                    .map((setting, i) => {
                    const name = setting.displayName;
                    const desc = setting.description;
                    const codes = setting.value.split(",");
                    return (React.createElement("div", { key: i },
                        React.createElement("div", { className: "settings__block-entry" },
                            React.createElement("div", { className: "settings__block-entry--title" }, name),
                            React.createElement("div", { className: "settings__block-entry--body" },
                                React.createElement("span", { className: "settings__block-entry--body-desc" }, desc))),
                        React.createElement("ul", { className: "settings__rejection" }, codes.map((code, i) => {
                            return (React.createElement("li", { style: { display: "flex", alignItems: "center" }, key: i },
                                React.createElement("span", { style: { minWidth: "fit-content" } },
                                    React.createElement("b", null, code)),
                                React.createElement("div", { style: {
                                        width: "100%",
                                        borderBottom: "1px dotted whitesmoke"
                                    } }),
                                React.createElement(material_ui_icons_1.Clear, { className: "settings__rejection--clear", onClick: () => this.handleDelete(code, setting.id), color: "error" })));
                        }))));
                }))));
        });
        const wrapper = (React.createElement("div", { className: "settings__wrapper" },
            React.createElement("div", { className: "settings__add" }, this.renderAddNew()),
            React.createElement("div", { className: "settings__block" }, blocks.map((e) => e))));
        return wrapper;
    }
    render() {
        const didLoad = !!this.settings;
        return (React.createElement("div", null, didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsDistributor.prototype, "settings", void 0);
__decorate([
    mobx_1.observable
], AppSettingsDistributor.prototype, "valueInput", void 0);
AppSettingsDistributor = __decorate([
    mobx_react_1.observer
], AppSettingsDistributor);
exports.AppSettingsDistributor = AppSettingsDistributor;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-distributor/app-settings-distributor.tsx
// module id = 3203
// module chunks = 0